import api from "./api";

const namespaced = true;

const state = {};

const mutations = {};

function formatUploadError(err) {
  if (!err) return "Upload failed";
  if (typeof err === "string") return err;
  if (err instanceof Error && err.message) return err.message;
  if (typeof err.data === "string" && err.data) return err.data;
  if (typeof err.message === "string" && err.message) return err.message;
  if (typeof err.statusText === "string" && err.statusText && err.statusText !== "Bad Request") {
    return err.statusText;
  }
  try {
    const serialized = JSON.stringify(err.data || err);
    if (serialized && serialized !== "{}") return serialized;
  } catch (_) {
    // ignore
  }
  return "Upload failed";
}

const actions = {
  uploadFile({ commit }, { name, file }) {
    if (!file || !file.name) {
      return Promise.reject("No file selected");
    }

    // Upload through the API so browser CORS/checksum issues are avoided,
    // and local/dev can fall back to disk storage when AWS is not configured.
    return api
      .uploadFile(name || file.name, file)
      .then((res) => {
        const payload = res.data || {};
        if (!payload.key) {
          throw new Error("Upload failed: missing storage key");
        }
        return payload;
      })
      .catch((err) => {
        throw formatUploadError(err);
      });
  },
};

const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
